import { render } from "./Sparkline.vue?vue&type=template&id=2c68c6ff&scoped=true"
import script from "./Sparkline.vue?vue&type=script&lang=js"
export * from "./Sparkline.vue?vue&type=script&lang=js"

import "./Sparkline.vue?vue&type=style&index=0&id=2c68c6ff&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c68c6ff"]])

export default __exports__